<template>
  <main class="bg-white">
    <div class="pb-5">
      <Hero :course="heroH5p ?? course" :role="user.role" />
      <InteractiveCard
        v-if="course?.embedType! && !loading"
        :data="{...course!,...heroH5p}"
      />

      <TabView
        v-if="!course?.embedType! && !loading"
        class="custom-tabs-course"
      >
        <TabPanel
          :header="
            $t('labels.generic', {
              pt: course.adaptive ? 'Grafo dos cursos' : 'Conteúdo do curso',
              en: course.adaptive ? 'Courses graph' : 'Course content',
            })
          "
        >
          <Content :data="course" :role="user?.role" />
        </TabPanel>
        <TabPanel
          :header="$t('labels.generic', { pt: 'Turmas', en: 'Classes' })"
        >
          <ClassroomContent />
        </TabPanel>
      </TabView>
    </div>
  </main>
</template>

<script lang="ts">
import { Course, CourseType } from "@/models/courses.model";
import { CoursesRest } from "@/services/rest/courses.rest";
import { GoToRoute } from "@/utils/go-to.util";
import HandleError from "@/utils/handle-errors.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { last, take } from "rxjs";
import { defineAsyncComponent, defineComponent } from "vue";
import { CourseService } from "../Course/course.service";

const Hero = defineAsyncComponent(() => import("./Hero/hero-chapters.vue"));
const InteractiveCard = defineAsyncComponent(
  () => import("./InteractiveCard/index.vue")
);
const Content = defineAsyncComponent(
  () => import("./Content/content-chapters.vue")
);
const ClassroomContent = defineAsyncComponent(
  () => import("./Classroom/content-classroom.vue")
);
export default defineComponent({
  name: "chapters",
  components: { Hero, Content, ClassroomContent, InteractiveCard },
  computed: {
    rest(): CoursesRest {
      return new CoursesRest();
    },
    service(): CourseService {
      return new CourseService();
    },
    errors(): HandleError {
      return new HandleError();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    user(): any {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      course: {} as Course | null | any,
      heroH5p: null as Course | null,
      loading: true,
    };
  },
  mounted() {
    this.getCourseById();
    this.getHero();
  },
  methods: {
    getCourseById(): void {
      const h5pId: any = this.$route.params.h5pId;
      const courseId: any = this.$route.params.id;
      const courseType: any = this.$route.params.type;
      this.service.course.pipe(take(2), last()).subscribe({
        next: (response) => {
          this.course = response;
          this.loading = false;
        },
      });

      this.service.getCoursesById(
        courseType ? h5pId : courseId,
        courseType === CourseType.INTERACTIVE ? "/h5p" : "/graphs"
      );
    },
    getHero(): void {
      const h5pId: any = this.$route.params.h5pId;
      const courseId: any = this.$route.params.id;
      if (h5pId === "") return;
      this.service.heroH5p.pipe(take(2), last()).subscribe({
        next: (response) => (this.heroH5p = response),
      });
      this.service.getHeroH5p(courseId);
    },
  },
});
</script>
